// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsbwdok{width:var(--_cjikvn)}\n._1e0c1ule{display:block}\n._4t3iwdok{height:var(--_cjikvn)}", ""]);
// Exports
module.exports = exports;
